const preloadWarning = "Error preloading route! ☝️";
export {
  preloadWarning
};
//# sourceMappingURL=link.js.map
